export const ServicesSection = {
  heading: "Customizable, End-to-End Services Built Around Your Requirements",
  description: "",
  services: [
    {
      name: "Optimisation and Management (GBP) Google Business Profiles",
      content:
        "We update and present your Google Business Profile which means your info will always be current and attractive. This in turn makes your business stand out on Maps and in local search results where the action is.",
    },
    {
      name: "Website and Content Optimisation",
      content:
        "Your site should be a perfect match to your SEO. We tailor your landing pages, blog content, and site structure to your social media efforts and search strategy which in turn gives users a consistent and conversion friendly experience.",
    },
    {
      name: "Review Management",
      content:
        "Reviews are that which can make or break local trust. We at [our company] watch over and manage your Google, Facebook, and Yelp reviews which in turn will have you responding professionally, sharing the good word, and turning happy customers into brand advocates.",
    },
    {
      name: "Link Building",
      content:
        "We partner with local influencers, directories, and publications to grow your online authority. Our links improve your SEO and connect your brand with what is relevant in your community.",
    },
  ],
};

const placeholderSVG = (color) => `
  <svg width="24" height="24" fill="${color}" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" fill="${color}" />
    <path d="M8 12l2 2 4-4" stroke="#fff" stroke-width="2" fill="none" />
  </svg>
`;

export const LargeData = {
  heading: "How to Choose the Best Local SEO Company?",
  description:
    "Choosing your local SEO partner is key to your business’ performance in your community and online. Here is what to look for as you choose your agency:",
  services: [
    {
      title: "Local SEO Packages",
      svg: placeholderSVG("#18336c"),
      content:
        "Look out for agencies which present full integrated packages which include social media marketing, local listings, review management and more. Why? Because consistent messages across many platforms increase trust and visibility. We present bundle local SEO optimization services that bring unity to your online presence which in turn makes your business appear professional, credible and engaging no matter where your customers find you.",
    },
    {
      title: "Local SEO Pricing",
      svg: placeholderSVG("#2f5597"),
      content:
        "Pricing is not a secret to us. Reputable agencies we work with provide clear and upfront pricing which is in fact a reflection of what you get in terms of service and scope. We are totally transparent, no hidden fees, no surprises. Our flexible packages are tailored for businesses at various growth stages, which in turn makes it easy for you to increase your local presence all while keeping to your budget.",
    },
    {
      title: "Industry Experience",
      svg: placeholderSVG("#006778"),
      content:
        "Not all SEO practices are the same and what works for a dental clinic may not work for a boutique café. That is because experience in many different industries is what we bring to the table. We have worked with clients in retail, healthcare, hospitality, legal and beyond which in turn gives us insight into how each industry approaches local audiences. We use this info to develop social content and SEO plans which we tailor to your market.",
    },
    {
      title: "Track Record of Success",
      svg: placeholderSVG("#8a3ffc"),
      content:
        "Trust agencies that prove what they do -- we do more than promise results. We show you real growth in local search rankings which we see translate into more website visits and we track that through to tangible results like increased leads and customer engagement. We share our success stories with local SEO experts through testimonials and case studies and we keep you in the loop with monthly reports so you are always in the know and confident in the strategy we are putting in place together.",
    },
    {
      title: "Local Search Optimisation Processes",
      svg: placeholderSVG("#1c7c54"),
      content:
        "A great local SEO company will have a clear, systematic process for local optimization. We optimize everything from your Google Business Profile to your social media bios, hashtags, and geo-tags. We also ensure your business appears in all relevant directories and local listings—boosting your visibility and helping you show up where it counts most in your customers’ local searches.",
    },
  ],
};


export const CustomSection = {
  heading: "Why Choose Warrgyizmorsch as Your Local SEO Agency?",
  description: ``,
  services: [
    {
      name: "Expert Local Knowledge",
      content:
        "We have at our disposal knowledge of your culture, trends, and online behaviours which we attain through research and analysis. That which we bring to the table gives us an edge in which we are able to put out content that is directed toward local audiences. We craft strategies that connect with the people in your area as opposed to180 degree wide national scale.",
    },
    {
      name: "Customised SEO Strategies",
      content:
        "No business is the same, we don’t treat them as such. We create tailored strategies for your specific industry which include local SEO and social content that best serves your goals. If what your local SEO service wants is more calls, more visits, or more followers we’ll produce it for you.",
    },
    {
      name: "Comprehensive Services",
      content:
        "In paid social campaigns, organic growth strategies, influencer outreach, and Google listings we handle it all. We are that one local SEO agency stop shop you won’t have to go to multiple agencies to get what you need.",
    },
    {
      name: "Ongoing Support and Communication",
      content:
        "We are very collaborative. Our team will keep you updated with progress reports and in for all check in’s. We value your input which in turn shapes our direction as your brand grows out which we do by keeping you in the loop at all times.",
    },
    {
      name: "Cost-Effective",
      content:
        "We have that our budgets do play a role. We offer services which are affordable and which scale as you do; we are designed to get you the best return on investment which means even the small business can stand out locally without breaking the bank. We grow with you.",
    },
    {
      name: "Enhanced User Experience",
      content:
        "We put out content which is not just for the eyes but for the experience. From Instagram stories to interactive posts and Google updates we do it all in a way which engages and inspires local users to take action.",
    },
    {
      name: "Ethical SEO Practices",
      content:
        "We are of the value that growth which is organic and transparent is the way to go, no cutting corners, no bots. We build every strategy on a base of long term trust and authenticity which in turn sees your audience grow in reality and your reputation stay strong.",
    },
    {
      name: "Use of the Latest Tools and Techniques",
      content:
        "We are at the forefront of platform updates and algorithm changes, also we use the latest in marketing tech. From in-depth analytics dashboards to smart scheduling and A/B testing tools we are into the very best resources which in turn we use to produce smart and informed results.",
    },
  ],
};


export const BenefitSection = {
  heading: "Why Choose Warrgyizmorsch?",
  description:
    "At Warrgyizmorsch not only do we provide local SEO but we also develop what we like to call “meaningful digital partnerships” which in turn help local businesses to do well. Here’s the story of how businesses from many different industries have chosen to grow with us:",
  services: [
    {
      name: "Local SEO Experts",
      //   logo: "https://cdn-icons-png.flaticon.com/512/1170/1170576.png",
      content:
        "Our team consists of professional experts in local SEO and social media marketing. We see that your customers are using Google and Instagram at the same time for service based searches which is what we pay attention to. Also we don’t look at SEO and social as separate entities. We put together a unified strategy which includes local keywords, location tags, hashtags and analysis of user behaviour to get your brand in front of the right people at the right time.",
    },
    {
      name: "Personal Account Management",
      //   logo: "https://cdn-icons-png.flaticon.com/512/942/942748.png",
      content:
        "When you do work with us you will not be put in contact with multiple departments. You will be put with a dedicated account manager which will know your business, your audience and your goals like the back of their hand. That person will be your main point of contact, will be your strategic partner and will advocate for you which in turn will see your brand’s voice remain consistent, your goals be made a priority and each campaign we roll out will tie in perfectly with your local market strategy.",
    },
    {
      name: "Proven and Flexible Strategy",
      //   logo: "https://cdn-icons-png.flaticon.com/512/1828/1828961.png",
      content:
        "We are not into one size fits all plans. Your business is unique, and thus your marketing strategy should be also. We develop proven data driven strategies which are very flexible. As you launch a new product, enter a new neighbourhood, or adjust to market shifts we tune and optimize your campaigns to keep you ahead. Our flexibility guarantees that your local SEO efforts will grow with your business.",
    },
    {
      name: "End-to-End Local Search Solution",
      //   logo: "https://cdn-icons-png.flaticon.com/512/889/889118.png",
      content:
        "From starting with audits and keyword research through social media content planning, Google Business Profile optimization, review management, and monthly analytics reporting we do it all. We are not just another agency for you, we are your full service team which means we local search engine take care of everything. Our all in one approach means you get a fully integrated strategy which covers all of your local online presence issues, so you can put your energy into growing what you do best and serving your customers.",
    },
  ],
};

export const BoostSection = {
  heading: "Expand Your Local Reach with Warrgyizmorsch Local SEO Services",
  description: `We turn to social media as a key component of your local SEO which in turn helps us reach out to nearby customers, promote local SEO solutions, community based events, and develop lasting local brand awareness. We do this via geo-targeted ads, engaging with Instagram stories, and posts to your Google Business Profile which in turn presents your brand as an active and trusted member of your neighbourhood. With us your brand doesn’t just appear in search results you stand out in your community.`,
  button: "Let’s Get Started",
};


export const FAQ = [
  {
    header: "Local SEO Service",
    question: "What Is Local SEO?",
    answer:
      "Local SEO is about fine tuning your digital space so your business shows up at the top in local searches. We cover your Google Business Profile, local content, reviews and social media interaction. Also we use social media marketing to help you to build out that online profile which in turn will connect you with local customers. It is best for small businesses, service providers, and brick and mortar locations that count on local traffic.",
  },
  {
    header: "Web Development",
    question: "How Much Does Local SEO Cost?",
    answer:
      "Local SEO prices which depend on what your business does, the size of your company and what you want to achieve. We have flexible pricing which we tailor to your needs without breaking the bank. We offer basic packages which may include citation building and Google Business Profile management and full service plans which may cover social media marketing, content creation and review management.",
  },
  {
    header: "Web Development",
    question: "How Long Does it Take to See Results from Local SEO?",
    answer:
      "Local SEO is a term for a play which pays off in the long run, but with consistent effort you’ll see results between 3 to 6 months. We do see faster results from optimizing Google Business Profile and use of social content, while competitive keywords still require time. Social media is a great tool for increase in visibility as your info is out there in real time and we see high engagement.",
  },
  {
    header: "Web Development",
    question:
      "Can Local SEO Help My Business if I Already Have Good Overall SEO?",
    answer:
      "Absolutely! In the local search engine optimization game we target nearby customers which general SEO often doesn’t. Maybe your site is ranking great for broad terms but still you are missing out on local traffic. By adding in location based content, optimizing your Google Business Profile, and getting into local social media we see to it that your brand is put in front of people in your area.",
  },
  {
    header: "Web Development",
    question: "Does Warrgyizmorsch Offer International SEO and Local SEO?",
    answer:
      "We do indeed provide international as well as local SEO services. Our focus is on the growth of local businesses which we help to expand their community presence but we also work with global brands looking to extend their reach across the world. For clients which have many locations or international audiences we tailor each campaign to the target region, we localise content, manage region specific social profiles and we align with search engine guidelines across countries.",
  },
  {
    header: "Web Development",
    question: "What Is the Best Local SEO London Agency?",
    answer:
      "We are proud to present Warrgyizmorsch as a top local SEO company in London. What makes us different is our blend of SEO skills and social media integration. We have a grasp of the London market from borough level trends to local hashtags and influencers. Our team brings data driven strategies, creative content and responsive support to each project.",
  },
  {
    header: "Web Development",
    question: "What Does a Local SEO Audit Include?",
    answer:
      "A local SEO audit looks at all aspects of your digital presence which is local in nature from your Google Business Profile to your website, online reviews, social media activity, and local backlinks. We look at NAP consistency, identify keyword opportunities, and we study your competitors. In terms of social we look at your engagement levels, content performance, and audience reach.",
  },
];

export const roleWriting = {
  heading: "Unlocking Growth: The Power of Local SEO for Your Business",
  content: `Social media marketing weaves into local SEO through the creation of shareable content which in turn gets people engaged and brings in local traffic. We put forward your brand on social platforms to increase your visibility, build trust, and get real world traffic to your business. We use location based hashtags, geo-tag content or boost community posts which we think will work best for you to put your brand in front of local users. `,
};
